// extracted by mini-css-extract-plugin
module.exports = {"solution":"Solution_solution__A27IP"};